import React, { Suspense } from 'react'
import { Container, Row, Col } from '@paypalcorp/pp-react'
import { useAppContext } from '../../contexts/app-context'

// Components
import TopicTree from '../../components/topic-tree'
import HeroModule from '../../components/hero-module'
import MoreWaysOfHelp from '../../components/more-ways-of-help'
import LoginPrompt from '../../components/login-prompt'
import Survey from '../../components/survey'

// Home page - This is the page/container for home view which will have the layout and components placement
function Home() {
  const appCtx = useAppContext()
  const { pageProps, reqContextData } = appCtx
  const { apiData } = pageProps
  const { topicTree, helpChannels } = apiData
  const { isLoggedIn } = reqContextData

  // TODO: Home page validations will be added later when we start on the Home page implementation
  return (
    <>
      <Suspense fallback={<span>Loading...</span>}>
        <HeroModule />
      </Suspense>

      <Container>
        <Row>
          <Col sm={12} md={6}>
            <TopicTree topicTreeData={topicTree.data} />
          </Col>
          <Col sm={12} md={6}>
            {!isLoggedIn && <LoginPrompt />}
          </Col>
        </Row>
        <Row>
          <MoreWaysOfHelp helpChannels={helpChannels.data} />
        </Row>
        <Row>
          <Survey />
        </Row>
      </Container>
    </>
  )
}

export default Home
